<div class="basicrow m-top">
    <div class="autowcont m-bott">
        <div class="basicrow msidespad">
            <div class="b-title">
                <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                    <div class="tabcell">
                        Resumen y Confirmaci&oacute;n
                    </div>
                </div>
            </div>
        </div>

        <div class="basicrow text-center m-top-u msidespad">
            <div class="userallinfo f-black  m-info-mob">
                <div class="phn-nmbr p-top-a">
                    <div class="basicrow">
                        <img width="100%" class="phn-icon" src="../../../assets/images/phn-icon.png">
                    </div>

                    <div class="basicrow m-top-u">
                        <span class="roboto-b">
                            N&uacute;mero de tel&eacute;fono
                        </span><br />

                        <span class=" f-btitle-i roboto-l">{{this.phoneNumber}}</span>
                    </div>
                </div>

                <div class="userinfo m-info-mob">
                    <div class="redstat">
                        <div class="autorow roboto-r pull-left">
                            Rol
                        </div>

                        <div class="autorow roboto-b pull-right" style="text-transform: uppercase;">
                            {{this.role}}
                        </div>
                    </div>
                    <div class="redstat m-top-ii">
                        <div class="autorow roboto-r pull-left">
                            Nombre
                        </div>

                        <div class="autorow roboto-b pull-right">
                            {{this.name}}
                        </div>
                    </div>

                    <div class="redstat m-top-ii">
                        <div class="autorow roboto-r pull-left">
                            Apellido
                        </div>

                        <div class="autorow roboto-b pull-right">
                            {{this.lastName}}
                        </div>
                    </div>

                    <div class="redstat m-top-ii">
                        <div class="autorow roboto-r pull-left">
                            Usuario
                        </div>

                        <div class="autorow roboto-b pull-right">
                            {{this.phoneNumber}}
                        </div>
                    </div>

                    <div class="redstat m-top-ii">
                        <div class="autorow roboto-r pull-left">
                            Correo electr&oacute;nico
                        </div>

                        <div class="autorow roboto-b pull-right">
                            {{this.email}}
                        </div>
                    </div>

                    <!-- <div class="redstat m-top-ii">
                            <div class="autorow roboto-r pull-left">
                                Direcci&oacute;n postal
                            </div>
    
                            <div class="autorow roboto-b pull-right">
                                PO BOX 100, PR 33334
                            </div>
                        </div> -->
                </div>
            </div>
        </div>

        <div class="basicrow m-top m-bott msidespad">
            <div class="basicrow topbord">
                <div class="basicrow f-reg f-black m-top-u-i">
                    <div class="basicrow text-center justified">
                        Se ha creado el usuario con éxito.
                    </div>

                    <div class="basicrow m-top-i text-center">
                        <a routerLink="/usersandpermissions" class="btns centr def-i red vcenter">
                            <span class="tabcell">
                                Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>